
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexzT33bZfrxtQrWMMSy3pZF1trM1QTWNtEAn7S07CO_YUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/index.vue?macro=true";
import { default as _91step_93MpERY_axbnql0hIL3uKxomv36FzrfQVVyNhYe1Zua6cMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/signup/[step].vue?macro=true";
import { default as indexHU3xNW1Gr4UaQe3FrInKp8wWV5A73wFVW0vrGb9BKEEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/portfolio/index.vue?macro=true";
import { default as _91step_93q_ArXVaTNt36bLd9XIqKTaJeM7349U9MpZmEbhEwAB0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/completion/[step].vue?macro=true";
import { default as edit_45availabilityD0c2nwx4tUNU7Fx_x5tEdoHkjI4xMKncRq8KYRF2YHYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/[profileIdOrAlias]/edit-availability.vue?macro=true";
import { default as _91profileIdOrAlias_93PV6cxFat5lnk4Xre7mKMyOnyd53Ktei0gNqeR0wPIi0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/[profileIdOrAlias].vue?macro=true";
import { default as _91experienceId_93_46clientpYe1gYkMmdjvVGWkLDxcpIkyQ0K9PvjhrC0OoS67hB8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experiences/[experienceId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.4.1_@types+node@24.12.0_@vue+compiler-sfc@3.5.25_better-sq_5ad3366fcdf6847132fde8c4f8944271/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as experiences_46clientLEetTYToJOETGbvM7GrAGoFnx_IFfmyfP_oXeh805zEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experiences.client.vue?macro=true";
import { default as sandboxqiM1_EXT5GCSfNMDpyL5VoLTgLgPfapPcjEz6ygdJtEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile/sandbox.vue?macro=true";
import { default as indexg5xA2ZKBKn70CTSJjypweUOlfWTt_ru_gPMmgvFwpZ0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/recommendations/index.vue?macro=true";
import { default as signup_45workflowsTsCIl34oZzt7XQleZSmdJWtq32rIh6F4DVVSPwe4JDAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/admin/signup-workflows.vue?macro=true";
import { default as demo4_G10FPpIKqbZMbHxlrPbFQCvUf_KelL1nQHBmzIUYoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/demo.vue?macro=true";
import { default as your_45skills8u1uoxFg_2m6FGAofF1wIO0d7ZPLNfV26GzquuetW8IMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-skills.vue?macro=true";
import { default as welcome_45back9TSQe57oEykHiNxfQBpQ_F8sFj6CT7T90jDmj_Ip_xoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-back.vue?macro=true";
import { default as your_45education3PsXHFNt147bKAjG2fz_WZGlZfT4bCjCC_uLUhUE2scMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-education.vue?macro=true";
import { default as your_45daily_45ratehfpI54CIzvc3nB5CFl09RYegKa2dGmGI5hl4If61a_kMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-daily-rate.vue?macro=true";
import { default as your_45top_45skillsyYPuYYytKIjUkLLIP5ZJyiz7dbuQSWDkqPaiH1l5V6UMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-top-skills.vue?macro=true";
import { default as verify_45your_45email0sqvGPcLNncETmGfwn0QupBznVIF3QU0Fs69IQ16orIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/verify-your-email.vue?macro=true";
import { default as your_45phone_45number83ALyg37p53h_zhLQTrpMze9lvQtxmWXjcTzZadc074Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-phone-number.vue?macro=true";
import { default as create_45your_45accountu5mf0WSnoSjIcdEPh9DIseLkRoULTmQt3fuH3O5yJjAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/create-your-account.vue?macro=true";
import { default as redirect_45to_45regular61ZcYqRsLNdK0WixAUY1U_ycc3ByC2bO0OwU616Dx8kMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/redirect-to-regular.vue?macro=true";
import { default as welcome_45to_45malt_45openUwhvw59aNZrAqA74Uej6Lt5QWi438O0vWxxQ3P_Om28Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt-open.vue?macro=true";
import { default as your_45profile_45pictureSIkcOz_3MlykHKuGYlQfC5_CKCfKQVFj_cgCt8ScUkkMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-profile-picture.vue?macro=true";
import { default as your_45work_45experience0NXWG3f7vU575NOWCH8T9jVnL6_Vci5pbF7IAPv3_lsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-work-experience.vue?macro=true";
import { default as complete_45your_45account3LqjTmfKncLxRcwsw3puXQO_dolNt5mg7TZS3gi0V8sMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/complete-your-account.vue?macro=true";
import { default as showcase_45your_45talentsSr24xkub4tRsDFijoyA7Ucau7ctm2Cnexqdz45y0r8YMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/showcase-your-talents.vue?macro=true";
import { default as your_45privacy_45settingsqyaLDTWKElQF0kSNVgPT5VJVPVUsRHvG3cRlWU5_KmUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-privacy-settings.vue?macro=true";
import { default as your_45working_45languages3JzawEbH94ORmWrGF7shpfaMgX12qf1dTBULl9J2mMMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-working-languages.vue?macro=true";
import { default as submit_45your_45applicationW3_fjNXJP3qdDZYGEHeg_Bsg16G_YZTVm5_E362kNMgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/submit-your-application.vue?macro=true";
import { default as your_45industry_45expertise7ad05s6_JwfRTl6S8OzCMhe3fatPPehVggsUuHPbmkYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-industry-expertise.vue?macro=true";
import { default as welcome_45to_45malt_45strategyCH0Z0PQElfpYIH8IrZ0Q_1h_lQBbLfhtjBx0HLh_2ZYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt-strategy.vue?macro=true";
import { default as your_45level_45of_45experienceHJrpYQlciGuhwod5qF5UEgAThDyaRON92SlTqj8P_EgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-level-of-experience.vue?macro=true";
import { default as create_45your_45account_45splitJIXv641ttYyMqRaaGM2tj0zGGIZ0mco_X6tpzHZRRaUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/create-your-account-split.vue?macro=true";
import { default as your_45freelancing_45experienceo9edrj8ZTOxY9N_glfsE1Z5h5fjJLxOQ1VePZqk_nIwMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-freelancing-experience.vue?macro=true";
import { default as your_45job_45title_45and_45categoryx3P_RpOSNkQsTRr8esRaj08wqTyEuibkkKTFY2y3loIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-job-title-and-category.vue?macro=true";
import { default as how_45would_45you_45describe_45yourselfBkjUsVO275ICs8GmJjKidHca438RlrXRcp8LXgN_tvQMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/how-would-you-describe-yourself.vue?macro=true";
import { default as welcome_45to_45malt_91_91funnelContext_93_9355kEBu2bgYWjwpCuNjDHXQHfswJtxIhUl6jl76wJV2YMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt[[funnelContext]].vue?macro=true";
import { default as your_45location_45and_45workplace_45preferenceTRHp71a0h1NdGrTTJC3EYQAwLcgYUQ8UBMfYjubbhT0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-location-and-workplace-preference.vue?macro=true";
import { default as indextUSOimsMGUOfkgyIG9S1Y0KJlpB748WIkuVaAcHjaNsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index.vue?macro=true";
import { default as index9EoTG7YcNpxQLq2LAEpAg5SdVRl8tvKRSIexN7gNWS4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-charter/index.vue?macro=true";
import { default as pdfQ_Wn_XFOYpHtx6AplpQ98UhDzi1fTZZXICg4qnHV9wMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/cv/[profileIdOrAlias]/pdf.vue?macro=true";
import { default as indexsWbgMGUnwbME09ZP_wRi_vYQvp33wIYc_uZyFKmoSfkMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mission-preferences/index.vue?macro=true";
import { default as indexV1_QI6c0OZ5trlKfEtDg7_nJDcMtr0Op2ezG6a5oTkAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/cv/[profileIdOrAlias]/index.vue?macro=true";
import { default as _91profileId_93RLjsUASpJb9Cv_V7DbbWuwKt1NcKWBVU2D7ww3WUaH0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/categories-update/[profileId].vue?macro=true";
import { default as _91profileId_93VUeN_EMjeuC3It2Jy5Uj89zhZe0mrG_TS417QCTRl4EMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/edit-availability/[profileId].vue?macro=true";
import { default as _91profileIdOrAlias_93CswzBx6u9IO4727K9miSdCgcI8F4S6p8VqjVadI7bg8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile/[profileIdOrAlias].vue?macro=true";
import { default as auth_45confirmedN3OKDkHJd_IEbu3RNNdb2Xvekb_W9BNTg0502hUOuDAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/reputation-provider/auth-confirmed.vue?macro=true";
import { default as edit_46client5Tj1nhjt5o7fu4y_PBqAIDw3_a83spl8m4oFiLJQsVEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/portfolio/[portfolioId]/edit.client.vue?macro=true";
import { default as starterA6d2GRxSKXHkjQng1o2VUXyAv3Obm2zkh9MyACdHLmgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile-qualification-panel/starter.vue?macro=true";
import { default as strategyc6_bUs8EdOPWa0ca_Ghhx4XDpZbQAKyGO_nzJ3_mcLUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/waiting-room/strategy.vue?macro=true";
import { default as _91projectId_93_46clientEKmSY2iB_UJ3fmJdPk5_PAnMuA6d1jJZjGEgGBy3Fv8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experience/from-project/[projectId].client.vue?macro=true";
import { default as reminder_45_91reminderToken_93__CjtA6aPtcSYJCMhlABEjF7xyme4zkNM_ndwg9ISQoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/reminder-[reminderToken].vue?macro=true";
import { default as _91profileHash_93K_G73bZgNtIi3l5WFysL_XPVtBEUyPjZlUGOP0zw6_wMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/branded-visual/[profileIdOrAlias]/png/[profileHash].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"profile-redirect"},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/index.vue")
  },
  {
    name: "signup-step",
    path: "/signup/:step()",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/signup/[step].vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    meta: { ...(indexHU3xNW1Gr4UaQe3FrInKp8wWV5A73wFVW0vrGb9BKEEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/portfolio/index.vue")
  },
  {
    name: "completion-step",
    path: "/completion/:step()",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/completion/[step].vue")
  },
  {
    name: "profileIdOrAlias",
    path: "/:profileIdOrAlias()",
    meta: { ...(_91profileIdOrAlias_93PV6cxFat5lnk4Xre7mKMyOnyd53Ktei0gNqeR0wPIi0Meta || {}), ...{"middleware":["profile-alias-and-other-redirect","draft-instant-conversation-save-and-redirect"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/[profileIdOrAlias].vue"),
    children: [
  {
    name: "profileIdOrAlias-edit-availability",
    path: "edit-availability",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/[profileIdOrAlias]/edit-availability.vue")
  }
]
  },
  {
    name: "experiences",
    path: "/experiences",
    meta: { ...(experiences_46clientLEetTYToJOETGbvM7GrAGoFnx_IFfmyfP_oXeh805zEMeta || {}), ...{"middleware":["auth"]} },
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experiences.client.vue")),
    children: [
  {
    name: "experiences-experienceId",
    path: ":experienceId()",
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experiences/[experienceId].client.vue"))
  }
]
  },
  {
    name: "mf-profile-sandbox",
    path: "/mf/profile/sandbox",
    meta: sandboxqiM1_EXT5GCSfNMDpyL5VoLTgLgPfapPcjEz6ygdJtEMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile/sandbox.vue")
  },
  {
    name: "recommendations",
    path: "/recommendations",
    meta: { ...(indexg5xA2ZKBKn70CTSJjypweUOlfWTt_ru_gPMmgvFwpZ0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/recommendations/index.vue")
  },
  {
    name: "admin-signup-workflows",
    path: "/admin/signup-workflows",
    meta: { ...(signup_45workflowsTsCIl34oZzt7XQleZSmdJWtq32rIh6F4DVVSPwe4JDAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/admin/signup-workflows.vue")
  },
  {
    name: "freelancer-signup-demo",
    path: "/freelancer-signup/demo",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/demo.vue")
  },
  {
    name: "freelancer-signup",
    path: "/freelancer-signup",
    meta: indextUSOimsMGUOfkgyIG9S1Y0KJlpB748WIkuVaAcHjaNsMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index.vue"),
    children: [
  {
    name: "freelancer-signup-index-your-skills",
    path: "your-skills",
    meta: your_45skills8u1uoxFg_2m6FGAofF1wIO0d7ZPLNfV26GzquuetW8IMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-skills.vue")
  },
  {
    name: "freelancer-signup-index-welcome-back",
    path: "welcome-back",
    meta: welcome_45back9TSQe57oEykHiNxfQBpQ_F8sFj6CT7T90jDmj_Ip_xoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-back.vue")
  },
  {
    name: "freelancer-signup-index-your-education",
    path: "your-education",
    meta: your_45education3PsXHFNt147bKAjG2fz_WZGlZfT4bCjCC_uLUhUE2scMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-education.vue")
  },
  {
    name: "freelancer-signup-index-your-daily-rate",
    path: "your-daily-rate",
    meta: your_45daily_45ratehfpI54CIzvc3nB5CFl09RYegKa2dGmGI5hl4If61a_kMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-daily-rate.vue")
  },
  {
    name: "freelancer-signup-index-your-top-skills",
    path: "your-top-skills",
    meta: your_45top_45skillsyYPuYYytKIjUkLLIP5ZJyiz7dbuQSWDkqPaiH1l5V6UMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-top-skills.vue")
  },
  {
    name: "freelancer-signup-index-verify-your-email",
    path: "verify-your-email",
    meta: verify_45your_45email0sqvGPcLNncETmGfwn0QupBznVIF3QU0Fs69IQ16orIMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/verify-your-email.vue")
  },
  {
    name: "freelancer-signup-index-your-phone-number",
    path: "your-phone-number",
    meta: your_45phone_45number83ALyg37p53h_zhLQTrpMze9lvQtxmWXjcTzZadc074Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-phone-number.vue")
  },
  {
    name: "freelancer-signup-index-create-your-account",
    path: "create-your-account",
    meta: create_45your_45accountu5mf0WSnoSjIcdEPh9DIseLkRoULTmQt3fuH3O5yJjAMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/create-your-account.vue")
  },
  {
    name: "freelancer-signup-index-redirect-to-regular",
    path: "redirect-to-regular",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/redirect-to-regular.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-malt-open",
    path: "welcome-to-malt-open",
    meta: welcome_45to_45malt_45openUwhvw59aNZrAqA74Uej6Lt5QWi438O0vWxxQ3P_Om28Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt-open.vue")
  },
  {
    name: "freelancer-signup-index-your-profile-picture",
    path: "your-profile-picture",
    meta: your_45profile_45pictureSIkcOz_3MlykHKuGYlQfC5_CKCfKQVFj_cgCt8ScUkkMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-profile-picture.vue")
  },
  {
    name: "freelancer-signup-index-your-work-experience",
    path: "your-work-experience",
    meta: your_45work_45experience0NXWG3f7vU575NOWCH8T9jVnL6_Vci5pbF7IAPv3_lsMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-work-experience.vue")
  },
  {
    name: "freelancer-signup-index-complete-your-account",
    path: "complete-your-account",
    meta: complete_45your_45account3LqjTmfKncLxRcwsw3puXQO_dolNt5mg7TZS3gi0V8sMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/complete-your-account.vue")
  },
  {
    name: "freelancer-signup-index-showcase-your-talents",
    path: "showcase-your-talents",
    meta: showcase_45your_45talentsSr24xkub4tRsDFijoyA7Ucau7ctm2Cnexqdz45y0r8YMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/showcase-your-talents.vue")
  },
  {
    name: "freelancer-signup-index-your-privacy-settings",
    path: "your-privacy-settings",
    meta: your_45privacy_45settingsqyaLDTWKElQF0kSNVgPT5VJVPVUsRHvG3cRlWU5_KmUMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-privacy-settings.vue")
  },
  {
    name: "freelancer-signup-index-your-working-languages",
    path: "your-working-languages",
    meta: your_45working_45languages3JzawEbH94ORmWrGF7shpfaMgX12qf1dTBULl9J2mMMMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-working-languages.vue")
  },
  {
    name: "freelancer-signup-index-submit-your-application",
    path: "submit-your-application",
    meta: submit_45your_45applicationW3_fjNXJP3qdDZYGEHeg_Bsg16G_YZTVm5_E362kNMgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/submit-your-application.vue")
  },
  {
    name: "freelancer-signup-index-your-industry-expertise",
    path: "your-industry-expertise",
    meta: your_45industry_45expertise7ad05s6_JwfRTl6S8OzCMhe3fatPPehVggsUuHPbmkYMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-industry-expertise.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-malt-strategy",
    path: "welcome-to-malt-strategy",
    meta: welcome_45to_45malt_45strategyCH0Z0PQElfpYIH8IrZ0Q_1h_lQBbLfhtjBx0HLh_2ZYMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt-strategy.vue")
  },
  {
    name: "freelancer-signup-index-your-level-of-experience",
    path: "your-level-of-experience",
    meta: your_45level_45of_45experienceHJrpYQlciGuhwod5qF5UEgAThDyaRON92SlTqj8P_EgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-level-of-experience.vue")
  },
  {
    name: "freelancer-signup-index-create-your-account-split",
    path: "create-your-account-split",
    meta: create_45your_45account_45splitJIXv641ttYyMqRaaGM2tj0zGGIZ0mco_X6tpzHZRRaUMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/create-your-account-split.vue")
  },
  {
    name: "freelancer-signup-index-your-freelancing-experience",
    path: "your-freelancing-experience",
    meta: your_45freelancing_45experienceo9edrj8ZTOxY9N_glfsE1Z5h5fjJLxOQ1VePZqk_nIwMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-freelancing-experience.vue")
  },
  {
    name: "freelancer-signup-index-your-job-title-and-category",
    path: "your-job-title-and-category",
    meta: your_45job_45title_45and_45categoryx3P_RpOSNkQsTRr8esRaj08wqTyEuibkkKTFY2y3loIMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-job-title-and-category.vue")
  },
  {
    name: "freelancer-signup-index-how-would-you-describe-yourself",
    path: "how-would-you-describe-yourself",
    meta: how_45would_45you_45describe_45yourselfBkjUsVO275ICs8GmJjKidHca438RlrXRcp8LXgN_tvQMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/how-would-you-describe-yourself.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-maltfunnelContext",
    path: "welcome-to-malt:funnelContext?",
    meta: welcome_45to_45malt_91_91funnelContext_93_9355kEBu2bgYWjwpCuNjDHXQHfswJtxIhUl6jl76wJV2YMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/welcome-to-malt[[funnelContext]].vue")
  },
  {
    name: "freelancer-signup-index-your-location-and-workplace-preference",
    path: "your-location-and-workplace-preference",
    meta: your_45location_45and_45workplace_45preferenceTRHp71a0h1NdGrTTJC3EYQAwLcgYUQ8UBMfYjubbhT0Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/index/your-location-and-workplace-preference.vue")
  }
]
  },
  {
    name: "freelancer-charter",
    path: "/freelancer-charter",
    meta: index9EoTG7YcNpxQLq2LAEpAg5SdVRl8tvKRSIexN7gNWS4Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-charter/index.vue")
  },
  {
    name: "cv-profileIdOrAlias-pdf",
    path: "/cv/:profileIdOrAlias()/pdf",
    meta: { ...(pdfQ_Wn_XFOYpHtx6AplpQ98UhDzi1fTZZXICg4qnHV9wMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/cv/[profileIdOrAlias]/pdf.vue")
  },
  {
    name: "mission-preferences",
    path: "/mission-preferences",
    meta: { ...(indexsWbgMGUnwbME09ZP_wRi_vYQvp33wIYc_uZyFKmoSfkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mission-preferences/index.vue")
  },
  {
    name: "cv-profileIdOrAlias",
    path: "/cv/:profileIdOrAlias()",
    meta: { ...(indexV1_QI6c0OZ5trlKfEtDg7_nJDcMtr0Op2ezG6a5oTkAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/cv/[profileIdOrAlias]/index.vue")
  },
  {
    name: "categories-update-profileId",
    path: "/categories-update/:profileId()",
    meta: { ...(_91profileId_93RLjsUASpJb9Cv_V7DbbWuwKt1NcKWBVU2D7ww3WUaH0Meta || {}), ...{"middleware":[]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/categories-update/[profileId].vue")
  },
  {
    name: "edit-availability-profileId",
    path: "/edit-availability/:profileId()",
    meta: _91profileId_93VUeN_EMjeuC3It2Jy5Uj89zhZe0mrG_TS417QCTRl4EMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/edit-availability/[profileId].vue")
  },
  {
    name: "mf-profile-profileIdOrAlias",
    path: "/mf/profile/:profileIdOrAlias()",
    meta: _91profileIdOrAlias_93CswzBx6u9IO4727K9miSdCgcI8F4S6p8VqjVadI7bg8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile/[profileIdOrAlias].vue")
  },
  {
    name: "reputation-provider-auth-confirmed",
    path: "/reputation-provider/auth-confirmed",
    meta: auth_45confirmedN3OKDkHJd_IEbu3RNNdb2Xvekb_W9BNTg0502hUOuDAMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/reputation-provider/auth-confirmed.vue")
  },
  {
    name: "portfolio-portfolioId-edit",
    path: "/portfolio/:portfolioId()/edit",
    meta: { ...(edit_46client5Tj1nhjt5o7fu4y_PBqAIDw3_a83spl8m4oFiLJQsVEMeta || {}), ...{"middleware":["auth"]} },
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/portfolio/[portfolioId]/edit.client.vue"))
  },
  {
    name: "mf-profile-qualification-panel-starter",
    path: "/mf/profile-qualification-panel/starter",
    meta: starterA6d2GRxSKXHkjQng1o2VUXyAv3Obm2zkh9MyACdHLmgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/mf/profile-qualification-panel/starter.vue")
  },
  {
    name: "freelancer-signup-waiting-room-strategy",
    path: "/freelancer-signup/waiting-room/strategy",
    meta: { ...(strategyc6_bUs8EdOPWa0ca_Ghhx4XDpZbQAKyGO_nzJ3_mcLUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/waiting-room/strategy.vue")
  },
  {
    name: "experience-from-project-projectId",
    path: "/experience/from-project/:projectId()",
    meta: { ...(_91projectId_93_46clientEKmSY2iB_UJ3fmJdPk5_PAnMuA6d1jJZjGEgGBy3Fv8Meta || {}), ...{"middleware":"auth"} },
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/experience/from-project/[projectId].client.vue"))
  },
  {
    name: "freelancer-signup-reminder-reminderToken",
    path: "/freelancer-signup/reminder-:reminderToken()",
    meta: reminder_45_91reminderToken_93__CjtA6aPtcSYJCMhlABEjF7xyme4zkNM_ndwg9ISQoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/freelancer-signup/reminder-[reminderToken].vue")
  },
  {
    name: "branded-visual-profileIdOrAlias-png-profileHash",
    path: "/branded-visual/:profileIdOrAlias()/png/:profileHash()",
    meta: _91profileHash_93K_G73bZgNtIi3l5WFysL_XPVtBEUyPjZlUGOP0zw6_wMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/app/pages/branded-visual/[profileIdOrAlias]/png/[profileHash].vue")
  }
]